// extracted by css-extract-rspack-plugin
export default {"Button":"settings-error-fallback-module__Button__Bw2YCog"};